import React, { useState, useEffect } from 'react';
import { Menu, Dropdown, Button, Drawer } from 'antd';
import { AiOutlineShoppingCart } from 'react-icons/ai';
import { MenuOutlined } from '@ant-design/icons';
import axios from 'axios';  // Import axios for API requests
import logo from '../images/logo-1.png';
import { IoMdArrowDropdown } from "react-icons/io";

import { FaChevronDown } from "react-icons/fa6";
import '../App.css';
import { Link, useLocation } from 'react-router-dom';
import categories from '../data/categories.json'

function Header() {
  const location = useLocation()
  const collectionItems = categories.map((item, ind) => ({
    key: ind,
    label: (
      <Link to={`/collection/${item.url}`}>
        {item.name}
      </Link>
    ),
  }))
  const [visible, setVisible] = useState(false);
  const [activeMenu, setActiveMenu] = useState('Home');
  const [products, setProducts] = useState([]);  // State to hold API data
  const [loading, setLoading] = useState(false); // Loading state

  const showDrawer = () => {
    setVisible(true);
  };

  const closeDrawer = () => {
    setVisible(false);
  };


  const jewelryMenu = (
    <Menu>
      {loading ? (
        <Menu.Item>Loading...</Menu.Item>
      ) : (
        products.map((product) => (
          <Menu.Item key={product.SKU}>{product.Name}</Menu.Item>
        ))
      )}
    </Menu>
  );

  // Function to set active menu
  const handleMenuClick = (menuItem) => {
    setActiveMenu(menuItem);
  };

  return (
    <div className="App">
      <header>
        <nav>
          <div className="theme-header">
            <div className="theme-logo">
              <Link to="/">     <img src={logo} alt="Logo" /></Link>
            </div>
            <div className="theme-menu">
              <ul>
                <li
                  className={location.pathname === '/' ? 'active' : ''}
                  onClick={() => handleMenuClick('Home')}
                >
                  <Link to='/'>Home</Link>
                </li>
                <li
                  className={location.pathname === '/engament' ?  'active' : ''}
                  onClick={() => handleMenuClick('about')}
                >
                  <Link to="/engament">Engagement/Wedding Rings</Link>
                </li>
                <li
                  className={location.pathname.includes('collection') ? 'active' : ''}
                  onClick={() => handleMenuClick('about')}
                >
                  <Dropdown menu={{ items: collectionItems }} placement="bottomCenter" arrow>
                    <Button>Collection</Button>
                  </Dropdown>

                </li>


                <li
                  className={location.pathname === '/About'? 'active' : ''}
                  onClick={() => handleMenuClick('WhoWeAre')}
                >
                  <Link to="/About">Who We Are</Link>
                </li>

                <li
                  className={location.pathname === '/Contact' ? 'active' : ''}
                  onClick={() => handleMenuClick('Contact')}
                >
                  <Link to="/Contact">Contact Us</Link>
                </li>

              </ul>
            </div>
            <div className="theme-cart">
              <Link to='/cart'>
                <AiOutlineShoppingCart size={24} />
              </Link>
            </div>
            <div className="theme-mobile-menu">
              <Button type="" onClick={showDrawer} icon={<MenuOutlined />} />
            </div>
          </div>
        </nav>
      </header>

      <Drawer
        title="Menu"
        placement="right"
        onClose={closeDrawer}
   
        visible={visible}
      >
        <ul>
    <li onClick={closeDrawer}>
      <Link to="/">Home</Link>
    </li>
    <li onClick={closeDrawer}>
      <Link to="/engament">Engagement/Wedding Rings</Link>
    </li>
    <li onClick={closeDrawer}>
      <Link to="/About">Who We Are</Link>
    </li>
    <li>
    <Dropdown menu={{ items: collectionItems }} placement="bottomCenter" arrow>
                    <Button>Collection <IoMdArrowDropdown /></Button>
                  </Dropdown>
    </li>
    <li onClick={closeDrawer}>
      <Link to="/Contact">Contact Us</Link>
    </li>
    {/* Collection Dropdown - Instead of a dropdown, show links directly */}

  </ul>
      </Drawer>
    </div>
  );
}

export default Header;
